@if (pdfDetails) {
  @if (pageIncluded(PDFPageKeys.PROJECT_DETAILS)) {
    <app-pdf-page-project-info [projectDetails]="pdfDetails.projectDetails"></app-pdf-page-project-info>
  }
  @if (pageIncluded(PDFPageKeys.QUICKSCAN)) {
    @if (needPageBreak(PDFPageKeys.QUICKSCAN)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-quickscan [pdfDetails]="pdfDetails"></app-pdf-page-quickscan>
  }
  @if (pageIncluded(PDFPageKeys.PROJECT_ANALYSIS)) {
    @if (needPageBreak(PDFPageKeys.PROJECT_ANALYSIS)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-project-analysis [pdfDetails]="pdfDetails" [options]="pageOptions(PDFPageKeys.PROJECT_ANALYSIS)"></app-pdf-page-project-analysis>
  }
  @if (pageIncluded(PDFPageKeys.TIS_QUICKSCAN)) {
    @if (needPageBreak(PDFPageKeys.TIS_QUICKSCAN)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-tis-quickscan [pdfDetails]="pdfDetails"></app-pdf-page-tis-quickscan>
  }
  @if (pageIncluded(PDFPageKeys.TIS)) {
    @if (needPageBreak(PDFPageKeys.TIS)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-project-tis [pdfDetails]="pdfDetails"></app-pdf-page-project-tis>
  }
  @if (pageIncluded(PDFPageKeys.RISK_RAINBOW)) {
    @if (needPageBreak(PDFPageKeys.RISK_RAINBOW)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-risk-rainbow [pdfDetails]="pdfDetails" [options]="pageOptions(PDFPageKeys.RISK_RAINBOW)"></app-pdf-page-risk-rainbow>
  }
  @if (pageIncluded(PDFPageKeys.RISK_RAINBOW_CLIENT)) {
    @if (needPageBreak(PDFPageKeys.RISK_RAINBOW_CLIENT)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-risk-rainbow [pdfDetails]="pdfDetails" [clientOnly]="true"></app-pdf-page-risk-rainbow>
  }
  @if (pageIncluded(PDFPageKeys.FORECAST_END_RESULT_LIST)) {
    @if (needPageBreak(PDFPageKeys.FORECAST_END_RESULT_LIST)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-forecast-end-result-list [pdfDetails]="pdfDetails"></app-pdf-page-forecast-end-result-list>
  }
  @if (pageIncluded(PDFPageKeys.MANDATING_FLOW)) {
    @if (needPageBreak(PDFPageKeys.MANDATING_FLOW)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-mandating-flow [pdfDetails]="pdfDetails"></app-pdf-page-mandating-flow>
  }
}
